import { useLocation } from 'react-router-dom'
import { useApp } from '@/context/AppContext'
import { DelayedLoader } from '@/components/DelayedLoader'

// Rute yang punya skeleton/placeholder sendiri → biarkan halaman yang menampilkan
// loading-nya (bukan overlay full-screen), supaya terasa lebih cepat & mulus.
const SELF_SKELETON = ['/projects', '/my-dashboard']

export function LoadingGate() {
  const { loading } = useApp()
  const pathname = useLocation().pathname
  if (!loading || pathname === '/login') return null
  if (SELF_SKELETON.some((p) => pathname === p || pathname.startsWith(p + '/'))) return null
  // Delayed: kalau data pertama keburu selesai sebelum ambang, loader tak muncul.
  return <DelayedLoader />
}
